<script>
  import Help from "../components/help.svelte";
  let helpId="Help20";
  </script>
  <svelte:head>
  <title>How to register | eAdmissions</title>
</svelte:head>
   
  <Help {helpId} showSearchOption={true} back="/help"/>